import React from "react"
import { Alert, Badge, Button, Card, Col, Container, Form, ListGroup, Row, Stack } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import { getAllQuestionsId, askQuestion } from "../../api/api_question"
import { shuffleArray, ucFirst } from "../../Common/js/generic_functions"
import { getStatistics } from "../../api/api_statistic"
import { getQuestionTypes } from "../../api/api_question_type"
import { getObjectIdKey } from "../../Common/js/getObjectIdKey"
import Question from "../Question/Question"
import { PatchQuestionFill } from "react-bootstrap-icons"
import { displayTriangle } from "../../Common/js/display_spatial_sequence"

class Play extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: false,
      allQuestionsId: [],
      remainingQuestionsId: [],
      statistics: [],
      questionTypes: [],
      questionTypesAsObject: {},
      currentQuestion: null,
      selectedQuestionsCount: 0,
      playScore: {
        right: 0,
        wrong: 0,
      },
      displayedExemples: {},
    }

    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.playNewGame = this.playNewGame.bind(this)
    this.getNextQuestion = this.getNextQuestion.bind(this)
    this.backMenu = this.backMenu.bind(this)
    this.updateSelectedQuestionsCount = this.updateSelectedQuestionsCount.bind(this)
    this.updatePlayScore = this.updatePlayScore.bind(this)
    this.getExempleStack = this.getExempleStack.bind(this)
  }

  componentDidMount() {
    this.props.setSplashFilterBrightness(50)
    this.getEntities()
  }

  async getEntities() {
    // CONFIG ==================================================================================================

    Promise.all([getAllQuestionsId(), getStatistics(), getQuestionTypes()]).then((promisesResults) => {
      let [allQuestionsId, statistics, questionTypes] = promisesResults

      this.dMgr.debug("getEntities allQuestionsId:", allQuestionsId)

      let formattedStatistics = this.formatStatistics(statistics)

      let questionTypesAsObject = getObjectIdKey(
        questionTypes["hydra:member"].map((questionType) => {
          questionType.isChecked = true
          return questionType
        }),
      )

      if (this.props.entityId !== undefined) {
        this.dMgr.debug("one question only:", this.props.entityId)
        allQuestionsId = allQuestionsId.filter((question) => {
          if (question.id === this.props.entityId) {
            return true
          } else {
            return false
          }
        })
      }

      this.dMgr.debug("getEntities formattedStatistics:", formattedStatistics)

      this.setState(
        {
          statistics: formattedStatistics,
          questionTypes: questionTypes["hydra:member"],
          questionTypesAsObject: questionTypesAsObject,
          allQuestionsId,
          isReadyToRender: true,
          selectedQuestionsCount: formattedStatistics.questions_count,
        },
        () => {
          if (this.props.entityId !== undefined) {
            this.playNewGame()
          }
        },
      )
    })

    // /CONFIG =================================================================================================
  }

  playNewGame() {
    let selectedQuestionTypes = this.state.questionTypes.map((questionType) => {
      if (this.state.questionTypesAsObject[questionType.id].isChecked === undefined || this.state.questionTypesAsObject[questionType.id].isChecked === true) {
        return questionType.id
      }
    })

    let remainingQuestionsId = this.state.allQuestionsId
      .filter((question) => {
        if (selectedQuestionTypes.indexOf(question.typeId) !== -1) {
          return true
        } else {
          return false
        }
      })
      .map((question) => {
        return question.id
      })
    remainingQuestionsId = shuffleArray(remainingQuestionsId)

    this.dMgr.debug("playNewGame remainingQuestionsId", remainingQuestionsId)
    this.setState({ remainingQuestionsId }, this.getNextQuestion)
  }

  async getNextQuestion() {
    this.dMgr.debug("getNextQuestion", this.state.remainingQuestionsId)

    let remainingQuestionsId = [...this.state.remainingQuestionsId]
    if (remainingQuestionsId.length === 0) {
      return null
    }
    let questionId = remainingQuestionsId.shift()

    let currentQuestion = await askQuestion(questionId)
    this.dMgr.debug("currentQuestion:", currentQuestion)
    this.setState({ remainingQuestionsId, currentQuestion })
  }

  backMenu() {
    this.props.setSplashFilterBrightness(50)
    this.setState({ currentQuestion: null })

    Promise.all([getStatistics()]).then((promisesResults) => {
      let [statistics] = promisesResults
      let formattedStatistics = this.formatStatistics(statistics)
      this.dMgr.debug("backMenu formattedStatistics:", formattedStatistics)

      this.setState({
        statistics: formattedStatistics,
        playScore: {
          right: 0,
          wrong: 0,
        },
      })
    })
  }

  formatStatistics(statistics) {
    let formattedStatistics = {}

    statistics["hydra:member"].forEach((statistic) => {
      if (statistic.name === "questions_count_by_types") {
        statistic.value = JSON.parse(statistic.value)
      }

      formattedStatistics[statistic.name] = statistic.value
    })

    return formattedStatistics
  }

  updateSelectedQuestionsCount() {
    let selectedQuestionsCount = 0

    this.state.questionTypes.forEach((questionType) => {
      if (questionType.isChecked) {
        selectedQuestionsCount += this.state.statistics.questions_count_by_types[questionType.id]
      }
    })

    this.setState({
      selectedQuestionsCount,
    })
  }

  updatePlayScore(playScore) {
    this.setState({
      playScore,
    })
  }

  getExempleStack(questionType) {
    switch (questionType.shortname) {
      default:
        return questionType.exemple.split("|").map((statement, index) => {
          let background = "black"
          let text = "white"
          if (statement === "?") {
            background = "warning"
            text = "black"
          }
          return (
            <Badge key={"statement_eg_" + questionType.id + "_" + index} bg={background} className={"text-" + text}>
              {statement}
            </Badge>
          )
        })
      case "spatial_suite_mcq":
        let fakeQuestion = {}
        fakeQuestion["statement" + ucFirst(this.props.i18n.resolvedLanguage)] = questionType.exemple
        return displayTriangle(fakeQuestion, this.props.i18n.resolvedLanguage)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = null
    if (this.state.currentQuestion === null) {
      toRender = (
        <>
          <Row className="text-center padding-bottom-15">
            <Col className="background-color-black padding-bottom-15 padding-top-15">
              <h2>
                {this.props.t("app.welcomeOn")} <span className="color1 font-weight-bold">Brainy</span> <span className="color2 font-weight-bold">Games</span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md={2}></Col>
            <Col md={8}>
              <Alert variant="dark" data-bs-theme="dark">
                <div className="margin-bottom-10">{this.props.t("app.hereRiddlesAndFun")}</div>
                {this.props.t("app.questionsOrdersChoseTypes").replace("|X|", this.state.questionTypes.length)} {this.props.t("app.dbp")}
                <br />
                <Form.Group key={"key_questiontype"}>
                  <ul>
                    {this.state.questionTypes.map((questionType) => {
                      let label = [
                        <span key={"label1_questiontype_" + questionType.id}>
                          {questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)] +
                            " (" +
                            this.state.statistics.questions_count_by_types[questionType.id] +
                            " " +
                            this.props.t("entity.questions").toLowerCase() +
                            ")"}
                        </span>,
                      ]

                      return (
                        <li className="li-no-bullet" key={"qtype_" + questionType.id}>
                          <Form.Check
                            className="display-inline-block"
                            type="checkbox"
                            label={label}
                            id={"questiontype_" + questionType.id}
                            key={"questiontype_" + questionType.id}
                            data-id={questionType.id}
                            checked={this.state.questionTypesAsObject[questionType.id].isChecked}
                            onChange={(e) => {
                              let questionTypesAsObject = { ...this.state.questionTypesAsObject }
                              questionTypesAsObject[e.target.dataset["id"]].isChecked = !questionTypesAsObject[e.target.dataset["id"]].isChecked

                              this.setState({ questionTypesAsObject }, this.updateSelectedQuestionsCount)
                            }}
                          />

                          <PatchQuestionFill
                            className="color1 margin-left-8 cursor-pointer"
                            onClick={() => {
                              this.props.showModal({
                                size: "lg",
                                hideOnClickOutside: true,
                                title: this.props.t("form.exemple") + this.props.t("app.dbp") + " " + questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)],
                                body: (
                                  <>
                                    <div className="margin-top-15">{questionType["commonStatement" + ucFirst(this.props.i18n.resolvedLanguage)]}</div>
                                    <div>
                                      <Stack className="justify-content-center margin-top-8" direction="horizontal" gap={3}>
                                        {this.getExempleStack(questionType)}
                                      </Stack>
                                    </div>
                                  </>
                                ),
                                bodyClass: "text-center text-white font-weight-bold",
                                footer: (
                                  <>
                                    <Button className="button-color1 margin-top-30" size="sm" onClick={this.props.hideModal}>
                                      {this.props.t("action.close")}
                                    </Button>
                                  </>
                                ),
                              })
                            }}
                          />
                        </li>
                      )
                    })}
                  </ul>
                </Form.Group>
                {this.props.t("app.youSelectedXQuestions").replace("|X|", this.state.selectedQuestionsCount)}
                <br />
                <div className="text-center">
                  <br />
                  <Button
                    className="button-color2"
                    disabled={this.state.selectedQuestionsCount <= 0}
                    onClick={() => {
                      this.playNewGame()
                    }}
                  >
                    {this.props.t("app.letsGo")}
                    {this.props.t("app.em")}
                  </Button>
                </div>
                <br />
                {this.props.t("app.totalXQuestionsAskedSince").replace("|X|", this.state.statistics.questions_asked_count)}
              </Alert>
            </Col>
          </Row>
          <Row className="padding-top-15">
            <Col md={3}></Col>
            <Col md={6}>
              <Alert variant="dark font-size-11" data-bs-theme="dark">
                <div dangerouslySetInnerHTML={{ __html: this.props.t("app.siteFreePolicy") }}></div>
                <br />
                {this.props.t("app.questionContact")} {this.props.t("app.dbp")}
                <br />
                {this.props.t("app.crypticAdminHalfredEmail")}
              </Alert>
            </Col>
          </Row>
        </>
      )
    } else {
      toRender = (
        <Row>
          <Col md={12}>
            <Question
              key={"question" + this.state.currentQuestion.id}
              setSplashFilterBrightness={this.props.setSplashFilterBrightness}
              backMenu={this.backMenu}
              getNextQuestion={this.getNextQuestion}
              currentQuestion={this.state.currentQuestion}
              playScore={this.state.playScore}
              updatePlayScore={this.updatePlayScore}
              selectedQuestionsCount={this.state.selectedQuestionsCount}
              remainingQuestionsId={this.state.remainingQuestionsId}
            />
          </Col>
        </Row>
      )
    }

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Play)
